import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    opacity: 0,
    animation: '$fadeIn 0.5s',
    'animation-fill-mode': 'forwards',
  },
  starIcon: {
    margin: '30px 0 40px 0',
    width: '120px',
    height: '120px',
  },
  title: {
    margin: '10px 0',
    fontSize: '33px',
    lineHeight: '33px',
    fontWeight: 700,
  },
  bottomText: {
    margin: '10px 0',
    fontSize: '28px',
    lineHeight: '28px',
    textAlign: 'center',
  },
  amount: {
    margin: '30px 0',
  },
  amount1: (props: { baseColors: BaseColors }) => {
    return {
      fontSize: '48px',
      color: props.baseColors.primary,
      fontWeight: 600,
    }
  },
  amount2: {
    fontSize: '18px',
    color: '#AEAEAE',
  },
  backButton: (props: { baseColors: BaseColors }) => {
    return {
      display: 'flex',
      margin: '10px',
      padding: '5px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      width: '50%',
      borderRadius: '15px',
      backgroundColor: props.baseColors.secondary,
      cursor: 'pointer',
    }
  },
  backButtonSpan: {
    display: 'inline-block',
    letterSpacing: '0.05em',
    lineHeight: '38px',
    fontSize: '25px',
    color: '#ffffff',
    fontFamily: 'Mulish',
  },
}))

export default buildStyles
